<script setup lang="ts"></script>

<template>
  <div class="brand-block">
    <img src="/images/color-top.svg" alt="" class="brand-block__color-top" role="presentation" />
    <div class="brand-block__inner">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.brand-block {
  background-color: theme('color-fg-app');
  display: flex;
  flex-direction: column;
  border-radius: space('xxsmall');
  box-shadow: 0 4px 32px 0 rgba(0, 0, 0, 0.2);
  width: min(100%, 16rem + space('huge') * 2);
  overflow: hidden;

  &__color-top {
    width: 100%;
  }

  &__inner {
    padding: space('xlarge') space('large') space('large');
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
